"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculatePercentage = exports.isNonNegativeInteger = void 0;
const isNonNegativeInteger = (n) => Number.isInteger(n) && n >= 0;
exports.isNonNegativeInteger = isNonNegativeInteger;
/**
 * Returns the percentage (in the integer range [0..100]) given a number of
 * completed items out of the total number of items.
 *
 * It returns the result as an integer, so the result is rounded to the
 * nearest one.
 *
 * @param n Number (non-negative integer) of completed items
 * @param total Number (non-negative integer) of total items
 */
const calculatePercentage = (n, total) => {
    if (!exports.isNonNegativeInteger(n)) {
        throw new Error("'n' must be a non-negative integer");
    }
    if (!exports.isNonNegativeInteger(total)) {
        throw new Error("'total' must be a non-negative integer");
    }
    if (n > total)
        throw new Error("'n' can't be greater than 'total'");
    return total === 0 ? 100 : Math.round((100 * n) / total);
};
exports.calculatePercentage = calculatePercentage;
//# sourceMappingURL=ff.js.map